import { render } from "./steps-component.vue?vue&type=template&id=045f1e6a"
import script from "./steps-component.vue?vue&type=script&lang=js"
export * from "./steps-component.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__